import React, { useEffect, useState, useContext } from 'react';
import axiosConn from '../../axiosConn';
import getAddressFromCoordinates from '../../utils/getAddressFromCoordinates';
import HuntCard from '../../components/huntCard/HuntCard';
import FilterBar from '../../components/filterBar/FilterBar';
import { AuthContext } from '../../context/AuthContext';
import useDebounce from '../../utils/useDebounce';
import HuntHeader from '../../components/huntHeader/HuntHeader';

const HuntListPage = () => {
  //   console.log('HuntListPage rendered');
  const { player } = useContext(AuthContext);
  const [hunts, setHunts] = useState([]);
  const [filteredHunts, setFilteredHunts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ city: '', region: '' });

  const debouncedFilters = useDebounce(filters, 300);

  // Fetch hunts from backend
  useEffect(() => {
    const fetchHunts = async () => {
      try {
        setLoading(true);
        const response = await axiosConn.get('hunts', {
          headers: {
            Authorization: `Bearer ${player?.token}`,
          },
        });
        // console.log('Hunts fetched response:', response.data.data);
        setHunts(response.data.data || []);
      } catch (err) {
        console.error('Failed to load hunts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchHunts();
  }, [player?.token]);

  // Apply client-side filters
  useEffect(() => {
    // console.log('Hunts:', hunts);
    // console.log('Debounced filters:', debouncedFilters);
    let filtered = hunts;
    // console.log('filtered', filtered, 'hunts', hunts);
    if (debouncedFilters.city) {
      filtered = filtered = filtered.filter((hunt) =>
        hunt.city?.toLowerCase().includes(debouncedFilters.city.toLowerCase()),
      );
      //   console.log('Filtered by city:', debouncedFilters.city, filtered);
    }
    if (debouncedFilters.region) {
      filtered = filtered.filter(
        (hunt) =>
          hunt.region
            ?.toLowerCase()
            .includes(debouncedFilters.region.toLowerCase()),
        // console.log('Filtered by region:', debouncedFilters.region, filtered),
      );
    }
    // console.log('Final filtered hunts:', filtered);
    setFilteredHunts(filtered);
  }, [debouncedFilters, hunts]);

  // Attempt geolocation to auto-suggest filters
  useEffect(() => {
    const autoDetectLocation = async () => {
      try {
        navigator.geolocation.getCurrentPosition(async (position) => {
          const { latitude, longitude } = position.coords;
          const { city, region } = await getAddressFromCoordinates(
            latitude,
            longitude,
          );
          const formatted = [city, region].filter(Boolean).join(', ');

          if (city && region && window.confirm(`Are you in ${formatted}?`)) {
            setFilters({ city, region });
          }
        });
      } catch (err) {
        console.warn('Geolocation error or user denied permission.');
      }
    };

    autoDetectLocation();
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleResetFilters = () => {
    setFilters({ city: '', region: '' });
  };

  //   console.log('Filtered hunts:', filteredHunts);
  return (
    <div className="container mt-4">
      {/* <h2 className="mb-4">🌎 JG Trailblazer Hunts</h2> */}
      <HuntHeader title="JG Trailblazer Treasure Hunts" />

      <FilterBar
        filters={filters}
        onFilterChange={handleFilterChange}
        onReset={handleResetFilters}
        player={player}
      />

      {loading ? (
        <div className="text-center mt-5">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : filteredHunts.length > 0 ? (
        <div className="row">
          {filteredHunts.map((hunt) => (
            <div className="col-md-6 mb-4" key={hunt._id}>
              <HuntCard hunt={hunt} />
            </div>
          ))}
        </div>
      ) : (
        <p>No hunts found for the selected filters.</p>
      )}
    </div>
  );
};

export default HuntListPage;
